import { render, staticRenderFns } from "./analogicalanalysis.vue?vue&type=template&id=2d64ea5c&scoped=true"
import script from "./analogicalanalysis.vue?vue&type=script&lang=js"
export * from "./analogicalanalysis.vue?vue&type=script&lang=js"
import style0 from "./analogicalanalysis.vue?vue&type=style&index=0&id=2d64ea5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64ea5c",
  null
  
)

export default component.exports